import {
  aboutUs,
  allCustomerReviews,
  backmarketWarranty,
  boMerchant,
  buyingGuides,
  cookiePolicy,
  dataProtection,
  giftFinder,
  help,
  hireExternal,
  medium,
  modelsComparison,
  referFriend,
  studentGoodDeals,
  termsService,
} from './shared-links'
import type { FooterConfig } from './types'

export const auConfig: FooterConfig = {
  columns: [
    {
      titleKey: 'categoryAbout',
      links: [aboutUs, hireExternal],
      socials: [
        { name: 'instagram', href: 'https://www.instagram.com/backmarket' },
        { name: 'x', href: 'https://x.com/backmarket' },
        {
          name: 'linkedin',
          href: 'https://linkedin.com/company/back-market',
        },
        {
          name: 'facebook',
          href: 'https://www.facebook.com/backmarketaus',
        },
      ],
    },
    {
      titleKey: 'categoryHelp',
      links: [
        {
          translationKey: 'becomeRefurbisher',
          href: 'https://backmarket.com.au/en-au/seller/home',
        },
        boMerchant,
        {
          translationKey: 'payment',
          href: 'https://help.backmarket.com/hc/en-au/articles/360026643854',
        },
        {
          translationKey: 'shipping',
          href: 'https://help.backmarket.com/hc/en-au/articles/360033250174',
        },
        {
          translationKey: 'return',
          href: 'https://help.backmarket.com/hc/en-au/categories/360002106194-Returns-refunds',
        },
        help,
        buyingGuides,
        giftFinder,
        modelsComparison,
        allCustomerReviews,
      ],
    },
    {
      titleKey: 'categoryServices',
      links: [referFriend, studentGoodDeals],
    },
    {
      titleKey: 'categoryLaw',
      links: [
        termsService,
        backmarketWarranty,
        dataProtection,
        cookiePolicy,
        { translationKey: 'paymentMethods', href: '' },
      ],
    },
    {
      titleKey: 'categoryHello',
      links: [
        {
          translationKey: 'trustpilot',
          href: 'https://fr.trustpilot.com/review/backmarket.com.au',
        },
        {
          translationKey: 'glassdoor',
          href: 'https://www.glassdoor.com.au/Overview/Working-at-Back-Market-EI_IE1780208.11,22.htm',
        },
        medium,
      ],
    },
    {
      logos: ['bcorp'],
    },
  ],
}
